import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-billing-control-create-round-modal',
  templateUrl: './billing-control-create-round-modal.component.html',
  styleUrls: ['./billing-control-create-round-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BillingControlCreateRoundModalComponent {
  private dialogRef = inject(DynamicDialogRef);
  private messageService = inject(MessageService);

  private static readonly MINIMUM_SCHEDULE_LEAD_MINUTES = 5;

  scheduledDate: Date | null = this.getSuggestedScheduleDate();
  minDate = this.getMinimumScheduleDate();

  setManualExecution(): void {
    this.scheduledDate = null;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.scheduledDate && this.scheduledDate < this.minDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Data inválida',
        detail: 'O agendamento deve ser pelo menos 5 minutos à frente.'
      });
      return;
    }

    this.dialogRef.close({
      dateScheduled: this.scheduledDate ? this.scheduledDate.toISOString() : null
    });
  }

  private getSuggestedScheduleDate(): Date {
    const date = new Date();
    date.setMinutes(date.getMinutes() + 10);
    date.setSeconds(0, 0);
    return date;
  }

  private getMinimumScheduleDate(): Date {
    const date = new Date();
    date.setMinutes(date.getMinutes() + BillingControlCreateRoundModalComponent.MINIMUM_SCHEDULE_LEAD_MINUTES);
    date.setSeconds(0, 0);
    return date;
  }
}
